/* eslint-disable react/display-name */
import { observer } from "mobx-react";
import cls from "classnames";
import { getFileIconFromName } from "logic/src/objects/file/utils";
import { ReactComponent as Exchange } from "@/assets/images/exchange.svg";
import { ReactComponent as LinkIcon } from "logic/src/components/icons/documents-icon/link.svg";
import { IChatSample, ESampleType } from "logic/src/objects/chatSample/types";
import styles from "./index.module.scss";
import { sendCLK } from "logic/src/utils/eventTrack";

const DOC_TYPE = [`${ESampleType.file}`, `${ESampleType.link}`];

const ChatSample = ({
  lineMode,
  samples,
  flushSample,
  selectSample,
}: {
  lineMode?: boolean;
  samples: IChatSample[];
  flushSample: () => void;
  selectSample: (sample: IChatSample) => void | Promise<void>;
}) => {
  const doc = samples
    ?.filter((item: IChatSample) => DOC_TYPE.includes(item.type))
    ?.map((item: IChatSample) => ({
      ...item,
      query: [item.query[0]],
    }))[0];
  const others = samples
    ?.filter((item: IChatSample) => !DOC_TYPE.includes(item.type))
    ?.slice(0, 3)
    ?.map((item: IChatSample) => ({
      ...item,
      query: [item.query[0]],
    }));

  if (lineMode) {
    const img = samples?.find(
      (item: IChatSample) => ESampleType.image === item.type,
    );
    const write = samples?.find(
      (item: IChatSample) => ESampleType.write === item.type,
    );
    return (
      <>
        {doc && (
          <span
            className={styles.sampleItem}
            onClick={() => {
              sendCLK("click_doc_summary", "总结文档_点击");
              selectSample(doc);
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M12.0861 8.44738C11.7083 8.44738 11.4038 8.75938 11.4038 9.1428C11.4027 9.3253 11.4738 9.50082 11.6016 9.63109C11.7294 9.76136 11.9036 9.83582 12.0861 9.83823H14.4999C14.5904 9.8374 14.6798 9.81876 14.763 9.78336C14.8463 9.74796 14.9218 9.6965 14.9852 9.63191C15.0485 9.56733 15.0985 9.49089 15.1323 9.40696C15.1662 9.32304 15.1831 9.23328 15.1822 9.1428C15.1822 8.75766 14.8759 8.44738 14.4999 8.44738H12.0861ZM12.0861 11.1811C11.7083 11.1811 11.4038 11.4931 11.4038 11.8759C11.4038 12.2594 11.7101 12.5713 12.0861 12.5713H14.0004C14.0909 12.5705 14.1803 12.5519 14.2636 12.5165C14.3469 12.4811 14.4223 12.4296 14.4857 12.365C14.5491 12.3004 14.5991 12.224 14.6329 12.1401C14.6667 12.0562 14.6836 11.9664 14.6827 11.8759C14.6827 11.4914 14.3764 11.1811 14.0004 11.1811H12.0861Z"
                fill="#FF5562"
              />
              <path
                d="M3.13833 2.00343H3.13033C2.54288 2.00343 2.05829 2.45943 2 3.04456V15.173C2.048 15.7273 2.48116 16.1702 3.02518 16.221H7.48591L9.36026 17.8947C9.51098 17.9652 9.67553 18.0012 9.84191 18C10.0083 17.9988 10.1723 17.9605 10.322 17.8879L12.1832 16.221H16.9777C17.532 16.1685 17.9686 15.7068 18 15.137L18 7.11599H16.6371V14.8336H11.9746C11.9681 14.835 11.9614 14.8356 11.9546 14.8353H11.9444C11.9364 14.837 11.9266 14.837 11.9181 14.8388H11.9164C11.8112 14.8525 11.7152 14.8896 11.6318 14.9439L10.01 16.4136C9.898 16.4319 9.77285 16.4325 9.66142 16.4136L8.03907 14.9439C7.95343 14.8877 7.85611 14.8517 7.75449 14.8388H7.75278C7.74414 14.8368 7.73534 14.8356 7.72649 14.8353H7.7162C7.70992 14.8336 7.70306 14.8336 7.69678 14.8336H3.36519V3.75827C3.37958 3.66413 3.42412 3.57721 3.49213 3.51054C3.56014 3.44387 3.64794 3.40107 3.74235 3.38856H8.19451C8.28838 3.4024 8.37526 3.4462 8.4422 3.51345C8.50914 3.58069 8.55255 3.66777 8.56595 3.7617V13.3125C8.56595 13.6976 8.8711 14.0079 9.24883 14.0079C9.33933 14.0071 9.42879 13.9884 9.51209 13.9531C9.59539 13.9177 9.6709 13.8662 9.73431 13.8016C9.79772 13.7371 9.8478 13.6606 9.88167 13.5767C9.91553 13.4928 9.93254 13.403 9.93171 13.3125V3.11599C9.91228 2.50857 9.43455 2.02057 8.83853 2H4.0395V2.00171H3.1389L3.13833 2.00343Z"
                fill="#FF5562"
              />
              <path
                d="M13.5941 6.74335L13.5941 6.74345L13.792 7.19822C13.8265 7.28145 13.8849 7.3526 13.9599 7.40269C14.0349 7.45287 14.1232 7.47965 14.2135 7.47965C14.3037 7.47965 14.392 7.45287 14.4671 7.40269C14.542 7.3526 14.6004 7.28145 14.6349 7.19822L14.8197 6.7735H14.8211L14.8341 6.74333C15.1766 5.95043 15.8038 5.31465 16.592 4.96136C16.592 4.96136 16.592 4.96135 16.592 4.96134L17.2026 4.69011L17.2026 4.69012L17.2035 4.68974C17.2855 4.65148 17.355 4.5906 17.4036 4.51424C17.4523 4.43788 17.4781 4.34923 17.4781 4.25869C17.4781 4.16815 17.4523 4.07949 17.4036 4.00314C17.355 3.92678 17.2855 3.8659 17.2035 3.82764L17.2035 3.82763L17.2027 3.82728L16.6255 3.57019C15.8172 3.20729 15.1789 2.54813 14.8422 1.72858L14.8421 1.72839L14.6391 1.24031C14.6058 1.15487 14.5474 1.08146 14.4717 1.02967C14.3958 0.97777 14.306 0.95 14.2141 0.95C14.1222 0.95 14.0324 0.97777 13.9565 1.02967C13.8808 1.08147 13.8224 1.15488 13.789 1.24033L13.5861 1.72972L13.5861 1.72982C13.2488 2.54842 12.6106 3.2066 11.8027 3.5689L11.2268 3.82602L11.2268 3.82601L11.2262 3.82628C11.1437 3.86436 11.0739 3.92526 11.025 4.00177C10.976 4.07829 10.95 4.16722 10.95 4.25805C10.95 4.34887 10.976 4.4378 11.025 4.51432C11.0739 4.59083 11.1437 4.65173 11.2262 4.68981L11.2267 4.69006L11.8362 4.96263C12.6242 5.31551 13.2514 5.95084 13.5941 6.74335ZM14.2135 5.53677C13.8655 5.02547 13.4168 4.58952 12.8949 4.25446C13.4193 3.91179 13.8681 3.46534 14.2135 2.94265C14.5588 3.46531 15.0075 3.91174 15.5319 4.2544C15.0103 4.58837 14.5618 5.02461 14.2135 5.53677Z"
                fill="#FF5562"
                stroke="#FF5562"
                stroke-width="0.1"
              />
            </svg>
            <span>总结文档</span>
          </span>
        )}
        {write && (
          <span
            className={styles.sampleItem}
            onClick={() => {
              sendCLK("click_assist_note", "帮写笔记_点击");
              selectSample(write);
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M4.78692 6.7235L4.58891 7.17866C4.55818 7.25295 4.5061 7.31645 4.43927 7.36112C4.37243 7.4058 4.29385 7.42965 4.21346 7.42965C4.13307 7.42965 4.05448 7.4058 3.98765 7.36112C3.92082 7.31645 3.86874 7.25295 3.83801 7.17866L3.64 6.7235C3.29235 5.91952 2.65606 5.27498 1.85661 4.917L1.24715 4.64442C1.17336 4.61034 1.11087 4.55584 1.06707 4.48737C1.02327 4.4189 1 4.33932 1 4.25805C1 4.17677 1.02327 4.09719 1.06707 4.02872C1.11087 3.96025 1.17336 3.90575 1.24715 3.87167L1.82318 3.61452C2.64269 3.24698 3.29014 2.5793 3.63228 1.74887L3.83544 1.25899C3.86512 1.1827 3.91715 1.11716 3.98472 1.07094C4.05229 1.02473 4.13224 1 4.2141 1C4.29596 1 4.37592 1.02473 4.44348 1.07094C4.51105 1.11716 4.56309 1.1827 4.59277 1.25899L4.79592 1.74759C5.13751 2.57898 5.78503 3.24766 6.60502 3.6158L7.18234 3.87296C7.25577 3.90719 7.31791 3.96167 7.36144 4.03C7.40498 4.09833 7.4281 4.17767 7.4281 4.25869C7.4281 4.33971 7.40498 4.41904 7.36144 4.48737C7.31791 4.5557 7.25577 4.61018 7.18234 4.64442L6.57159 4.91571C5.77199 5.27411 5.1357 5.91911 4.7882 6.7235H4.78692ZM5.62525 4.25483C5.05653 3.89707 4.57433 3.41752 4.21346 2.85077C3.85259 3.41752 3.37039 3.89707 2.80167 4.25483C3.36741 4.60456 3.84958 5.07258 4.21346 5.62674C4.57789 5.07156 5.05985 4.60321 5.62525 4.25483ZM10.3132 14.6798C13.4248 14.3005 15.7752 12.0556 16.6046 9.78363L16.6174 9.75148L15.7701 8.92859L16.683 8.03756L16.692 8.02984C17.2899 7.44096 17.8981 6.39306 18.514 4.86814C18.676 4.46955 18.838 4.03625 19 3.5708C18.5204 3.57595 18.0575 3.5978 17.6114 3.63766C12.5981 4.07611 9.64333 6.59364 7.83423 9.59076C6.20386 12.2909 5.50182 15.3831 5.08008 17.7142C5.0055 18.1257 4.93864 18.5114 4.87821 18.8701L4.85635 19H6.17814C6.4533 17.7271 6.92518 16.7242 7.60151 16.0016C8.2984 15.2533 9.20617 14.8135 10.3132 14.6798ZM14.8726 8.0067C14.7498 8.12648 14.6521 8.26965 14.5855 8.42776C14.5188 8.58586 14.4844 8.75572 14.4844 8.92731C14.4844 9.0989 14.5188 9.26875 14.5855 9.42686C14.6521 9.58496 14.7498 9.72813 14.8726 9.84791L15.0784 10.0472C14.2104 11.6518 12.4232 13.1266 10.1576 13.4031C8.97473 13.5471 7.92552 13.9817 7.06662 14.7313C7.48836 13.2346 8.07339 11.6801 8.93487 10.2542C10.4727 7.7084 12.9028 5.53931 17.0662 4.99029C16.5802 6.08962 16.143 6.7685 15.7855 7.11823L14.8726 8.00541V8.0067Z"
                fill="#FFB820"
              />
            </svg>
            帮写笔记
          </span>
        )}
        {/* 临时需求，先把画图隐藏 */}
        {/* {img && (
          <span className={styles.sampleItem} onClick={() => selectSample(img)}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M10.7595 18.78H10.6995C9.27953 18.76 8.23953 17.76 7.85953 16.08C7.19953 13.12 5.99953 13.24 4.33953 13.42C3.37953 13.52 2.29953 13.64 1.47953 12.9C0.819531 12.3 0.519531 11.3 0.519531 9.75995C0.519531 5.03995 4.35953 1.19995 9.07953 1.19995C12.8595 1.19995 16.2395 3.73995 17.2995 7.37995C17.4195 7.79995 17.1795 8.23995 16.7595 8.37995C16.3395 8.49995 15.8995 8.25995 15.7595 7.83995C14.8995 4.87995 12.1595 2.81995 9.07953 2.81995C5.23953 2.81995 2.11953 5.93995 2.11953 9.77995C2.11953 11.14 2.39953 11.6 2.55953 11.74C2.83953 12 3.47953 11.92 4.17953 11.86C5.87953 11.68 8.45953 11.4 9.43953 15.76C9.75953 17.2 10.4995 17.2 10.7395 17.22H10.7595C12.3995 17.18 14.9995 14.74 15.7995 11.64C15.9195 11.22 16.3395 10.96 16.7795 11.06C17.1995 11.18 17.4595 11.6 17.3595 12.04C16.3995 15.66 13.3395 18.78 10.7595 18.78Z"
                fill="#FFB820"
              />
              <path
                d="M3.33984 8.96003C3.33984 9.32072 3.48313 9.66664 3.73818 9.92169C3.99323 10.1767 4.33915 10.32 4.69984 10.32C5.06054 10.32 5.40646 10.1767 5.66151 9.92169C5.91656 9.66664 6.05984 9.32072 6.05984 8.96003C6.05984 8.78143 6.02467 8.60458 5.95632 8.43958C5.88797 8.27458 5.7878 8.12465 5.66151 7.99836C5.53522 7.87208 5.3853 7.7719 5.22029 7.70355C5.05529 7.63521 4.87844 7.60003 4.69984 7.60003C4.52125 7.60003 4.3444 7.63521 4.17939 7.70355C4.01439 7.7719 3.86447 7.87208 3.73818 7.99836C3.61189 8.12465 3.51171 8.27458 3.44337 8.43958C3.37502 8.60458 3.33984 8.78143 3.33984 8.96003ZM7.61984 5.80003C7.61984 5.93398 7.64623 6.06661 7.69749 6.19037C7.74875 6.31412 7.82388 6.42656 7.9186 6.52128C8.01331 6.61599 8.12575 6.69113 8.24951 6.74239C8.37326 6.79365 8.5059 6.82003 8.63984 6.82003C8.77379 6.82003 8.90643 6.79365 9.03018 6.74239C9.15393 6.69113 9.26638 6.61599 9.36109 6.52128C9.45581 6.42656 9.53094 6.31412 9.5822 6.19037C9.63346 6.06661 9.65984 5.93398 9.65984 5.80003C9.65984 5.66608 9.63346 5.53344 9.5822 5.40969C9.53094 5.28594 9.45581 5.1735 9.36109 5.07878C9.26638 4.98406 9.15393 4.90893 9.03018 4.85767C8.90643 4.80641 8.77379 4.78003 8.63984 4.78003C8.5059 4.78003 8.37326 4.80641 8.24951 4.85767C8.12575 4.90893 8.01331 4.98406 7.9186 5.07878C7.82388 5.1735 7.74875 5.28594 7.69749 5.40969C7.64623 5.53344 7.61984 5.66608 7.61984 5.80003ZM12.0198 7.16003C12.0198 7.38281 12.1083 7.59647 12.2659 7.754C12.4234 7.91153 12.6371 8.00003 12.8598 8.00003C13.0826 8.00003 13.2963 7.91153 13.4538 7.754C13.6113 7.59647 13.6998 7.38281 13.6998 7.16003C13.6998 6.93725 13.6113 6.72359 13.4538 6.56606C13.2963 6.40853 13.0826 6.32003 12.8598 6.32003C12.6371 6.32003 12.4234 6.40853 12.2659 6.56606C12.1083 6.72359 12.0198 6.93725 12.0198 7.16003ZM10.1198 12.78C9.77984 12.78 9.47984 12.58 9.35984 12.24C9.21984 11.82 9.43984 11.36 9.85984 11.22L18.4798 8.20003C18.8998 8.06003 19.3598 8.28003 19.4998 8.70003C19.6398 9.12003 19.4198 9.58003 18.9998 9.72003L10.3798 12.74C10.2798 12.76 10.1998 12.78 10.1198 12.78Z"
                fill="#FFB820"
              />
            </svg>
            AI画图
          </span>
        )} */}
      </>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        {doc && (
          <div className={styles.left} onClick={() => selectSample(doc)}>
            <div className={styles.header}>
              <img src={doc?.icon} alt="" />
              {doc?.query?.[0].title}
            </div>
            <div className={styles.file}>
              {doc.query?.[0].file?.map(
                (item: IChatSample["query"][number]["file"][number]) => {
                  const Icon =
                    doc.type === ESampleType.link
                      ? LinkIcon
                      : getFileIconFromName(item.name);
                  return (
                    <div
                      key={item.id}
                      className={cls(styles.fileTitle, {
                        [styles.fileLinkTitle]: doc.type === ESampleType.link,
                      })}
                    >
                      <div className={styles.fileIcon}>
                        <Icon />
                      </div>
                      {doc.type === ESampleType.link ? (
                        <div>
                          <div className={styles.fileLink}>{item.url}</div>
                          <span className={styles.fileText}>{item.name}</span>
                        </div>
                      ) : (
                        <span className={styles.fileText}>{item.name}</span>
                      )}
                    </div>
                  );
                },
              )}
              <p className={styles.fileContent}>{doc?.query?.[0].message}</p>
            </div>
          </div>
        )}
        {!!others?.length && (
          <div className={styles.right}>
            {others.map((item: IChatSample) => (
              <div
                key={item.type}
                className={styles.group}
                onClick={() => selectSample(item)}
              >
                <div className={styles.header}>
                  <img src={item.icon} alt="" />
                  {item.query?.[0].title}
                </div>
                <div className={styles.text}>{item.query?.[0].message}</div>
              </div>
            ))}
          </div>
        )}
      </div>
      <div className={styles.footer} onClick={flushSample}>
        <Exchange className={styles.exchange} />
        换一换
      </div>
    </div>
  );
};

export default observer(ChatSample);
